import { __assign } from "tslib";
// DS9.1
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import { Url } from '@wix/da-url';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { useIsCurrentUserDeviationAuthor } from '../../utils/hooks/useIsCurrentUserDeviationAuthor';
import useTierPopup from '../../Tier/TierPopup/useTierPopup';
import Avatar from '../../User/Avatar';
import BasicUserName from '../../User/BasicUserName';
import SubscriberStat from '../../Stats/SubscriberStat';
import TierPriceWithBadge from '../Helper/TierPriceWithBadge';
import MinimalDumbo from '../Dumbo/MinimalDumbo';
import { getTierDescription } from '../_helpers';
import s from './TierSidebarCard.scss';
var TierSidebarCard = function (_a) {
    var deviation = _a.deviation, biData = _a.biData, className = _a.className, showEdit = _a.showEdit, _b = _a.noClickOrView, noClickOrView = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var isOwner = useIsCurrentUserDeviationAuthor(deviation);
    var openEditTierPopup = useTierPopup(deviation);
    var deviationId = deviation.deviationId, author = deviation.author, title = deviation.title;
    var _c = deviation.tier || {}, dollarPrice = _c.dollarPrice, isUserSubscribed = _c.isUserSubscribed;
    var description = getTierDescription(deviation);
    if (!author || !dollarPrice) {
        return null;
    }
    // TODO: bi
    var button;
    var onCardClick = {};
    // Edit button for owners
    if (showEdit && isOwner) {
        button = (
        // these use isFakeButton to prevent link nesting
        React.createElement(GhostButton, { size: "medium", variant: "edit-purple", isFakeButton: true, tabIndex: -1 }, t('common.edit')));
        onCardClick = { onClick: openEditTierPopup };
        // Sub/unsub button for subscribed
    }
    else if (isUserSubscribed) {
        button = (React.createElement(SolidButton, { size: "medium", variant: 'approval-green', priority: "secondary", isFakeButton: true, tabIndex: -1 }, t('deviationview.tierCard.cta.subscribed')));
        onCardClick = {
            href: Url.userLink(author.username, '/subscriptions'),
        };
        // View button - only with not disabled
    }
    else if (!noClickOrView) {
        button = (React.createElement(GhostButton, { size: "medium", variant: "main", isFakeButton: true, tabIndex: -1 }, t('deviationview.tierCard.explore')));
        onCardClick = {
            href: Url.deviationLink(deviationId, author.username, title),
        };
    }
    return (React.createElement(PlainButtonOrLink, __assign({ className: classnames(s['root'], className, noClickOrView && !button && s['no-clicks']), biData: biData }, onCardClick),
        React.createElement("div", { className: s['user-info'] },
            React.createElement(Avatar, { user: author, size: 24, withLink: false }),
            React.createElement(BasicUserName, { usernameClassName: s['username'], user: author })),
        deviation.coverImage && (React.createElement(MinimalDumbo, { className: s['image'], deviation: deviation.coverImage, height: 152, width: 274 })),
        title && React.createElement(Heading, { className: s['title'] }, title),
        React.createElement(SubscriberStat, { className: s['subscribers'], deviation: deviation }),
        description && React.createElement("div", { className: s['description'] }, description),
        React.createElement("hr", { className: s['divider'] }),
        React.createElement(Flex, { alignItems: "center" },
            React.createElement(TierPriceWithBadge, { className: s['price'], price: dollarPrice }),
            button)));
};
TierSidebarCard.displayName = 'TierSidebarCard';
export default TierSidebarCard;
//# sourceMappingURL=TierSidebarCard.js.map